import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <header className="hero-section">
      <div className="grid-overlay"></div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          <div className="title-container">
            <span className="stock-khata-text">STOCK</span>
            <span className="stock-khata-text">KHATA</span>
          </div>
          <span className="vertical-line"></span>
          <span className="sub-text">invest anywhere maintain only here</span>
        </h1>
        <div className="hero-buttons">
          <button 
            className="btn btn-primary"
            onClick={handleLoginRedirect}
          >
            Start Maintaining
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;